import React from "react";
import PropTypes from "prop-types";

function SVGIcon({ name, flip, rotate }) {
    var useTag = `<use xlink:href="#${name}" />`;
    const className = `svg-icon svg-icon-${name}`;
    let styles = {};
    if (flip) {
        styles["transform"] = "rotateY(180deg)";
    }
    if (rotate) {
        styles["transform"] = `rotate(${rotate}deg)`;
    }
    return (
        <svg style={styles} className={className} dangerouslySetInnerHTML={{ __html: useTag }} />
    );
}

export default SVGIcon;

SVGIcon.propTypes = {
    flip: PropTypes.bool,
    name: PropTypes.string.isRequired,
    rotate: PropTypes.number
};
SVGIcon.defaultProps = {
    flip: false
};
